(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.headerFlowTop = this.header.offsetTop;
      this.onResizeHandler = () => {
        if (!this.header.classList.contains('shopify-section-header-sticky')) {
          this.headerFlowTop = this.header.offsetTop;
        }
      };
      window.addEventListener('resize', this.onResizeHandler);
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.menuWasOpen = false;
      this.menuOpenedDetached = false;
      this.menuCloseAt = 0;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const past = scrollTop > this.headerBounds.bottom;
      const atTop = scrollTop <= this.headerFlowTop;
      const open = this.menuIsOpen();

      // Rising edge: the menu just opened. Remember whether the header was
      // already detached at that moment — that decides how it behaves.
      if (open && !this.menuWasOpen) {
        this.menuOpenedDetached = this.header.classList.contains('shopify-section-header-sticky');
      }
      this.menuWasOpen = open;

      if (open) {
        if (atTop) this.menuOpenedDetached = false;

        if (this.menuOpenedDetached && !atTop) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          if (!this.menuOpenedDetached && this.menuOffScreen()) {
            this.closeMenu();
            this.menuWasOpen = false;
          }
          requestAnimationFrame(this.reset.bind(this));
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && past) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && past) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (atTop) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }
    menuIsOpen() {
      const burger = this.header.querySelector('[data-sfa-menu-toggle]');
      const dd     = this.header.querySelector('[data-sfa-menu]');
      const search = this.header.querySelector('details-modal.header__search details');
      return !!(
        (burger && burger.classList.contains('is-open')) ||
        (dd     && dd.classList.contains('is-open'))     ||
        (search && search.hasAttribute('open'))
      );
    }
    menuOffScreen() {
    const dd = this.header.querySelector('[data-sfa-menu]');
    const el = (dd && dd.classList.contains('is-open') && dd.getBoundingClientRect().height)
      ? dd
      : this.header;
    return el.getBoundingClientRect().bottom <= 0;
    }
    hide() {
      this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
    }
    closeMenu() {
      const burger = document.querySelector('[data-sfa-menu-toggle]');
      const dd = document.querySelector('[data-sfa-menu]');
      const ov = document.querySelector('.sfa-menu-overlay');
      const searchDetails = document.querySelector('details-modal.header__search details');
      const searchOpen = !!(searchDetails && searchDetails.hasAttribute('open'));

      // Suppress the fade — this close is never seen, only its side effects.
      this.header.classList.add('sfa-no-anim');

      if (burger) {
        burger.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      }
      if (dd) dd.classList.remove('is-open');
      // Leave the dim in place if the search card is still open — it shares it.
      if (ov && !searchOpen) ov.classList.remove('is-open');

      void this.header.offsetHeight; // commit the un-transitioned state
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.header.classList.remove('sfa-no-anim'));
      });
    }
    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      super.hide();
    }
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }
    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              var ProductRecommendations_slider = $('.ProductRecommendations--slider');
              if (ProductRecommendations_slider.length > 0){
                $('.ProductRecommendations--slider').slick({
                  slidesToShow: 4,
                  slidesToScroll: 4,
                  dots: true,
                  arrows: true,
                  prevArrow: '<button type="button" class="slick-arrow slick-prev" aria-label="Previous recommended products"><svg aria-hidden="true" focusable="false" viewBox="0 0 11 18"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-34.000000, -437.000000)" stroke="currentColor" stroke-width="2"><g transform="translate(0.000000, 158.000000)"><g transform="translate(40.000000, 288.000000) scale(-1, 1) translate(-40.000000, -288.000000) translate(20.000000, 268.000000)"><polyline points="16 12 24 20 16 28"/></g></g></g></g></svg></button>',
                  nextArrow: '<button type="button" class="slick-arrow slick-next" aria-label="Next recommended products"><svg aria-hidden="true" focusable="false" viewBox="0 0 11 18"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1395.000000, -437.000000)" stroke="currentColor" stroke-width="2"><g transform="translate(0.000000, 158.000000)"><g transform="translate(1380.000000, 268.000000)"><polyline points="16 12 24 20 16 28"/></g></g></g></g></svg></button>',
                  responsive: [
                    {
                      breakpoint: 990,
                      settings: {
                          slidesToShow: 3,
                          slidesToScroll: 3,
                          arrows: false,
                      }
                    },
                    {
                      breakpoint: 750,
                      settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1,
                          centerMode: true,
                          centerPadding: '40px',
                          arrows: false,
                      }
                    }
                  ]
                });
              }
            } else {
              // CLS: no recommendations came back for this product. Release the height
              // reserved in section-product-recommendations.css so we don't leave a
              // ~629px hole above the footer. See that file for the full rationale.
              this.classList.add('product-recommendations--empty');
            }
          })
          .catch(e => {
            // Same as the empty case: never strand the reserved height on a failed fetch.
            this.classList.add('product-recommendations--empty');
            console.error(e);
          });
      }

      // CLS: rootMargin was '0px 0px 200px 0px'. 200px of lead time is not enough for a
      // ~60KB section fetch plus Slick init to finish before the element scrolls into
      // view, so the growth happened on-screen and counted against CLS. Widening to
      // 1600px means the fetch, the innerHTML swap and any empty-case collapse all
      // complete while the element is still well below the fold, where layout shifts
      // are not counted. Belt-and-braces with the min-height reservation: the min-height
      // handles a slow fetch, this handles the empty/error collapse. Changed 2026-07-18.
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 1600px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
